export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6cf01b0e5ecc90f190a344a7f07c8fca.jpg"
          alt="Celeste Tarot fondo místico"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-10 flex flex-col items-center">
        <p
          className="text-[#C9A84C] text-sm md:text-base tracking-[0.3em] uppercase mb-6 opacity-0 animate-[fadeInDown_1s_ease_0.2s_forwards]"
        >
          Lecturas de Tarot Profesionales
        </p>
        <h1
          className="text-4xl md:text-6xl lg:text-7xl font-light text-white leading-tight mb-6 opacity-0 animate-[fadeInDown_1s_ease_0.4s_forwards]"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Descubre lo que el<br />
          <span className="italic text-[#C9A84C]">universo</span> tiene<br />
          para ti
        </h1>
        <p
          className="text-[#e8dcc8]/80 text-base md:text-lg max-w-xl mb-10 leading-relaxed opacity-0 animate-[fadeInDown_1s_ease_0.6s_forwards]"
        >
          Lecturas de tarot personalizadas para guiar tu camino, iluminar tu presente y abrirte a las posibilidades del futuro.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 opacity-0 animate-[fadeInDown_1s_ease_0.8s_forwards]">
          <button
            onClick={() => handleScroll("#contacto")}
            className="bg-[#C9A84C] text-[#0d0a07] px-8 py-3 rounded-full text-sm font-semibold hover:bg-[#e0bc5e] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Reserva tu lectura
          </button>
          <button
            onClick={() => handleScroll("#servicios")}
            className="border border-[#C9A84C]/60 text-[#C9A84C] px-8 py-3 rounded-full text-sm font-medium hover:border-[#C9A84C] hover:bg-[#C9A84C]/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Ver servicios
          </button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-0 animate-[fadeIn_1s_ease_1.5s_forwards]">
          <span className="text-[#C9A84C]/60 text-xs tracking-widest uppercase">Descubre más</span>
          <div className="w-px h-10 bg-gradient-to-b from-[#C9A84C]/60 to-transparent animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
